/**
 * MUI Select icon — must be passed as a component reference to
 * `slotProps.select.IconComponent`. Cannot be used as <Icon name="..." />.
 * MUI appends `MuiSelect-iconOpen` to `className` when the dropdown is open;
 * the component reads it to drive the CSS rotation.
 */

import type { CSSProperties, ReactElement } from 'react';

export function SelectChevronIcon({ className, style }: { className?: string; style?: CSSProperties }): ReactElement {
	return (
		<svg
			className={className}
			xmlns="http://www.w3.org/2000/svg"
			width="14"
			height="8"
			viewBox="0 0 14 8"
			fill="none"
			aria-hidden="true"
			focusable="false"
			style={{
				transform: className?.includes('MuiSelect-iconOpen')
					? 'translateY(-50%) rotate(180deg)'
					: 'translateY(-50%) rotate(0deg)',
				transformOrigin: '50% 50%',
				transition: 'transform 280ms cubic-bezier(0.22, 1, 0.36, 1)',
				...style
			}}
		>
			<path
				d="M6.99993 8L7.59341 7.45067L14 1.50871L12.8131 0L7 5.39257L1.18694 0L0 1.50871L6.40659 7.45067L6.99993 8Z"
				fill="currentColor"
			/>
		</svg>
	);
}
